import GeneralService, { ApiKeyOrGetter } from "./GeneralService";

export interface DriftCheck {
  id: number;
  model_id: number;
  finetune_run_id: number;
  model_profile_id: number;
  window_start: string;
  window_end: string;
  request_count: number;
  novel_count: number;
  psi: number | null;
  wasserstein: number | null;
  drift_detected: boolean;
  centroid_distances: any;
  date_created: string;
  meta: Record<string, any>;
}

export interface DriftSummary {
  model_id: number;
  model_name: string;
  needs_training: boolean;
  last_check: DriftCheck | null;
  total_checks: number;
}

export class DriftService {
  public static getDriftModels(
    loadingHandler: ((val: boolean) => void) | undefined,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.get(
      "/drift/models",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getDriftHistory(
    modelId: number,
    loadingHandler: ((val: boolean) => void) | undefined,
    apiKey: ApiKeyOrGetter,
    limit: number = 20
  ) {
    return GeneralService.get(
      `/drift/models/${modelId}/checks?limit=${limit}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static triggerDriftCheck(
    modelId: number,
    loadingHandler: ((val: boolean) => void) | undefined,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.post(
      `/drift/models/${modelId}/check`,
      JSON.stringify({}),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getDriftCheck(
    checkId: number,
    loadingHandler: ((val: boolean) => void) | undefined,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.get(
      `/drift/checks/${checkId}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
}
